export default "__VITE_ASSET__CPT7IPK2__"